import React from 'react';
import { useTranslation } from 'react-i18next';
import { PageTitle } from '../../../shared/Typography/PageTitle';
import { useParams } from 'react-router-dom';

export const Quotation = () => {
    const { quoteId } = useParams();
    const { t } = useTranslation('quotations', {
        keyPrefix: 'QUOTATIONS',
    });

    return (
        <>
            <PageTitle>{t('TITLE')}</PageTitle>
        </>
    );
};
